
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"23","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M8.76 22.74v-7.68H6.38v-3.53h2.38v-1.52c0-3.93 1.78-5.75 5.64-5.75.47 0 .94.04 1.41.1.37.04.74.1 1.1.19v3.2c-.21-.02-.42-.03-.63-.03h-.7c-.55-.03-1.1.08-1.61.3-.27.14-.5.34-.65.6-.27.52-.4 1.1-.36 1.69v1.24h3.77l-.37 2.02-.28 1.5h-3.13V23c6.32-.78 10.82-6.53 10.05-12.86C22.22 3.81 16.46-.69 10.13.09 3.81.86-.69 6.62.09 12.94c.58 4.74 4.03 8.64 8.67 9.79v.01z","fill":"#1F4053"}})])
          )
        }
      }
    